import { defineComponent as _defineComponent } from 'vue'
import { onBeforeMount, ref } from 'vue';
import { useConfigStore } from '@/store';
import WphkBanner, { BannerConfig } from '@tencent/wphk-components-banner';
import { ModuleName } from '@/types/module-type';


export default /*#__PURE__*/_defineComponent({
  __name: 'bottom-banner',
  props: {
    moduleName: null
  },
  emits: ['onHideModule'],
  setup(__props: any, { emit }) {

const props = __props as { moduleName: ModuleName }




const { getConfig } = useConfigStore();
const bannerList = ref<BannerConfig[]>();

onBeforeMount(async () => {
  const { bannerList: bannerListVal = [] } = await getConfig(props.moduleName);
  if (bannerListVal.length) {
    bannerList.value = bannerListVal;
  } else {
    emit('onHideModule', ModuleName.JapanBottomBanner);
  }
});

return { __sfc: true,props, emit, getConfig, bannerList, WphkBanner }
}

})